




















import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import Report from "@/models/report/Report";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import ReportCardBasicData from "@/components/report/ReportCardBasicData.vue";
import ReportCardDateAndTime from "@/components/report/ReportCardDateAndTime.vue";
import ReportCardAdditionalInfosDriver from "@/components/report/ReportCardAdditionalInfosDriver.vue";
import ReportCardAdditionalInfosAdministration
	from "@/components/report/ReportCardAdditionalInfosAdministration.vue";
import ReportCardBill from "@/components/report/ReportCardBill.vue";
import ReportCardReportLines from "@/components/report/ReportCardReportLines.vue";
import {enumToSelectItems} from "@/helpers/functions_asi";
import {Permissions, ReportState} from "@/helpers/constants";
import StateBar from "@/components/StateBar.vue";
import CardBlamable from "@/components/CardBlamable.vue";

@Component({
	components: {
		CardBlamable,
		StateBar,
		ReportCardReportLines,
		ReportCardBill,
		ReportCardAdditionalInfosAdministration,
		ReportCardAdditionalInfosDriver, ReportCardDateAndTime, ReportCardBasicData, AsiContentContainer
	}
})
export default class ReportTabDetails extends Vue {

	@Prop({type: Object, required: true})
	public report!: Report;

	private reportStates = enumToSelectItems(ReportState, true);

	private get showBillingCard(): boolean {
		return (this.isCustomer || this.isOffice) && (this.report.bill !== null || this.report.state !== ReportState.created);
	}

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	private get isCustomer(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCustomer);
	}

	@Emit('reportChanged')
	public reportChanged(event: Event): Event {
		return event;
	}

}
